module.exports = __webpack_public_path__ + "img/upload-03.b93b93ce.svg";